import { useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const FaviconUpdater = () => {
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const response = await axios.get(`${apiUrl}/settings`);
        const settings = response.data;
        
        if (settings.site_favicon) {
          // Fetch favicon media details
          try {
            const mediaResponse = await axios.get(`${apiUrl}/media`);
            const faviconMedia = mediaResponse.data.find(m => m.id === parseInt(settings.site_favicon));
            if (faviconMedia) {
              const baseUrl = apiUrl.replace('/api', '');
              const faviconUrl = `${baseUrl}/api/uploads/${faviconMedia.filename}`;
              
              // Remove existing favicon links
              const existingLinks = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
              existingLinks.forEach(link => link.remove());
              
              // Create new favicon link
              const link = document.createElement('link');
              link.rel = 'icon';
              link.type = faviconMedia.filetype || 'image/x-icon';
              link.href = faviconUrl;
              document.head.appendChild(link);
              
              // Also update apple-touch-icon if it's the same image
              const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
              if (appleTouchIcon) {
                appleTouchIcon.href = faviconUrl;
              }
            }
          } catch (err) {
            console.error('Error fetching favicon media:', err);
          }
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Keep default favicon on error
      }
    };

    updateFavicon();
  }, []);

  return null; // This component doesn't render anything
};

export default FaviconUpdater;
